(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .service('InvoiceUtilsService', InvoiceUtilsService);

    InvoiceUtilsService.$inject = ['$localStorage', '$window', '$translate', 'toastr', 'externalChannelConstants'];

    var PAYMENT_LINK_CREATE_ERROR_KEYS = {
        paymentLinkConditionNotActiveForStore: 'payment-condition-not-enabled'
    };

    var SHIPPING_OPTION_LABEL_KEYS = {
        PICK_UP_IN_STORE: 'invoice.details.title.deliveryMethodPickupInStore',
        RECEIVE_AT_HOME: 'invoice.details.title.deliveryMethodReceiveAtHome'
    };

    function InvoiceUtilsService($localStorage, $window, $translate, toastr, externalChannelConstants) {
        var service = {
            getExternalChannelOptions: getExternalChannelOptions,
            getExternalChannelLabel: getExternalChannelLabel,
            getTreatedName: getTreatedName,
            buildSellerFilter: buildSellerFilter,
            getPaymentConditionOptions: getPaymentConditionOptions,
            isPaymentConditionSelected: isPaymentConditionSelected,
            togglePaymentCondition: togglePaymentCondition,
            buildPaymentLinkMessage: buildPaymentLinkMessage,
            buildPaymentLinkUrl: buildPaymentLinkUrl,
            resolvePaymentLinkCreateErrorKey: resolvePaymentLinkCreateErrorKey,
            isPaymentLinkEnabled: isPaymentLinkEnabled,
            copyPaymentLink: copyPaymentLink,
            canCopyPaymentLink: canCopyPaymentLink,
            canRegeneratePaymentLink: canRegeneratePaymentLink,
            hasPositiveFixedValue: hasPositiveFixedValue,
            resolveFixedValueInputAction: resolveFixedValueInputAction,
            autoSelectSalesPoint: autoSelectSalesPoint,
            formatSalesPointAddress: formatSalesPointAddress,
            buildInvoiceRequest: buildInvoiceRequest,
            buildPaymentLinkRequest: buildPaymentLinkRequest,
            validateInvoiceForSave: validateInvoiceForSave,
            hasInvalidShippingAddress: hasInvalidShippingAddress,
            validateInvoiceItems: validateInvoiceItems,
            validatePaymentLinkInvoice: validatePaymentLinkInvoice,
            validateCustomerBaseData: validateCustomerBaseData,
            getShippingOptionLabelKey: getShippingOptionLabelKey
        };
        return service;

        function getExternalChannelOptions(includeAllChannels) {
            var options = includeAllChannels === false
                ? []
                : [{ value: null, label: $translate.instant('invoice.salesChannel.all') }];
            angular.forEach(externalChannelConstants, function (labelKey, value) {
                options.push({ value: value, label: $translate.instant(labelKey) });
            });
            return options;
        }

        function getExternalChannelLabel(externalChannel) {
            if (!externalChannel) {
                return $translate.instant('invoice.salesChannel.notInformed');
            }
            var labelKey = externalChannelConstants[externalChannel];
            return labelKey ? $translate.instant(labelKey) : externalChannel;
        }
        
        // shippingMethod is free text from carriers (e.g. "Motoboy", ".Com"); only the panel's own shippingOption codes are translated
        function getShippingOptionLabelKey(shippingMethod) {
            if (!shippingMethod || !Object.prototype.hasOwnProperty.call(SHIPPING_OPTION_LABEL_KEYS, shippingMethod)) {
                return null;
            }
            return SHIPPING_OPTION_LABEL_KEYS[shippingMethod];
        }

        function getTreatedName(item) {
            if (item.fullName.length > 20) {
                var treatedlastName = ' ';
                item.lastName.split(' ').forEach(function (lastName) {
                    treatedlastName = treatedlastName.concat(lastName[0]).concat('. ');
                });
                var treatedName = item.firstName + treatedlastName;

                return treatedName.toLowerCase().trim().split(' ').map(function (word) {
                    return word[0].toUpperCase() + word.substring(1);
                }).join(' ');
            }

            return item.fullName.toLowerCase().trim().split(' ').map(function (word) {
                return word[0].toUpperCase() + word.substring(1);
            }).join(' ');
        }

        function buildSellerFilter(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(seller) {
                return seller.firstName.toLowerCase().indexOf(lowercaseQuery) >= 0
                    || (seller.lastName && seller.lastName.toLowerCase().indexOf(lowercaseQuery) >= 0);
            };
        }

        function getPaymentConditionOptions(prefix) {
            return [
                { value: 'BOLETO', labelKey: prefix + '.boleto' },
                { value: 'CREDIT_CARD', labelKey: prefix + '.credit-card' },
                { value: 'MONEY', labelKey: prefix + '.money' },
                { value: 'PIX', labelKey: prefix + '.pix' }
            ];
        }

        function isPaymentConditionSelected(list, value) {
            return Array.isArray(list) && list.indexOf(value) !== -1;
        }

        function togglePaymentCondition(list, value) {
            var idx = list.indexOf(value);
            if (idx === -1) {
                list.push(value);
            } else {
                list.splice(idx, 1);
            }
        }

        function buildPaymentLinkMessage(customer, prefix) {
            var name = customer && customer.fullName ? customer.fullName.split(' ')[0] : '';
            var key = name
                ? prefix + '.payment-link-message-default-with-name'
                : prefix + '.payment-link-message-default-without-name';
            return $translate.instant(key, { customerName: name });
        }

        function isPaymentLinkEnabled() {
            return !!($localStorage.defaultStore
                && $localStorage.defaultStore.storeInfo
                && $localStorage.defaultStore.storeInfo.paymentLinkEnabled);
        }

        function buildPaymentLinkUrl(uuid) {
            var info = ($localStorage.defaultStore && $localStorage.defaultStore.storeInfo) || {};
            var protocol = $window.location.protocol;
            if (info.redirectUrl) {
                return protocol + '//' + info.redirectUrl + '/payment-link/' + uuid;
            }
            return protocol + '//' + info.nickname + '.' + getDomainNameSufix($window, info.storeType)
                + '/payment-link/' + uuid;
        }

        function resolvePaymentLinkCreateErrorKey(error) {
            var body = error && error.data && error.data.data;
            var errorKey = body && body.errorKey;
            return PAYMENT_LINK_CREATE_ERROR_KEYS[errorKey] || 'error-to-create-payment-link';
        }

        function copyPaymentLink(uuid) {
            var url = buildPaymentLinkUrl(uuid);
            return copyToClipboard(url).then(function () {
                toastr.success($translate.instant('invoice.actions.copy-link-success'));
            }).catch(function () {
                toastr.error($translate.instant('invoice.actions.copy-link-error'));
            });
        }

        function canCopyPaymentLink(invoice) {
            return !!invoice && invoice.type === 'PAYMENT_LINK' && invoice.status === 'WAITING_PAYMENT' && isPaymentLinkEnabled();
        }

        function canRegeneratePaymentLink(invoice) {
            return !!invoice && invoice.type === 'PAYMENT_LINK' && invoice.status === 'NOT_PAID' && isPaymentLinkEnabled();
        }

        function hasPositiveFixedValue(fixedValue) {
            return angular.isNumber(fixedValue) && fixedValue > 0;
        }

        // Devolve 'RESET_WITH_WARNING' | 'RESET' | 'NONE'. O controller decide o que fazer
        // (toastr + $scope.$applyAsync(...) pra zerar vm.fixedValue e recalcular preço).
        function resolveFixedValueInputAction(hasItems, fixedValue) {
            var positiveValue = hasPositiveFixedValue(fixedValue);
            var nonPositiveNumber = angular.isNumber(fixedValue) && fixedValue <= 0;
            if (hasItems && positiveValue) {
                return 'RESET_WITH_WARNING';
            }
            if (nonPositiveNumber) {
                return 'RESET';
            }
            return 'NONE';
        }

        function autoSelectSalesPoint(salesPoints, currentSelectedId) {
            if (currentSelectedId) {
                return currentSelectedId;
            }
            if (!salesPoints || !salesPoints.length) {
                return null;
            }
            if (salesPoints.length === 1) {
                return String(salesPoints[0].id);
            }
            var mainPoint = _.find(salesPoints, function (point) {
                return point.mainPoint === true;
            });
            return String((mainPoint || salesPoints[0]).id);
        }

        function formatSalesPointAddress(point) {
            if (!point) {
                return '';
            }
            var streetPart = [point.address, point.number].filter(Boolean).join(', ');
            var cityPart = [point.city, point.state].filter(Boolean).join('/');
            var tailPart = [point.neighborhood, cityPart].filter(Boolean).join(', ');
            return [streetPart, tailPart].filter(Boolean).join(' — ');
        }

        // Monta o request base a partir da invoice (usado tanto por save() quanto por
        // buildPaymentLinkRequest). Mapeia customerIdentity -> cpf e phone -> phoneNumber;
        // só remapeia campos de endereço (street/streetNumber/zipCode) fora do contexto Immo.
        function buildInvoiceRequest(invoice, isImmoContext, selectedSalesPointId) {
            var request = angular.copy(invoice);
            if (request.customer.customerIdentity) {
                request.customer.cpf = request.customer.customerIdentity;
            }
            request.customer.phoneNumber = request.customer.phone;
            if (invoice.shippingOption === 'RECEIVE_AT_HOME' && !isImmoContext) {
                request.customer.street = request.customer.address;
                request.customer.streetNumber = request.customer.addressNumber;
                request.customer.zipCode = request.customer.zipcode;
            }
            if (invoice.shippingOption === 'PICK_UP_IN_STORE' && selectedSalesPointId) {
                request.salesPointId = selectedSalesPointId;
            }
            return request;
        }

        // options: { isImmoContext, fixedValue, standaloneProductName, selectedSalesPointId, paymentLinkMessage }
        function buildPaymentLinkRequest(invoice, options) {
            var request = buildInvoiceRequest(invoice, options.isImmoContext, options.selectedSalesPointId);
            var customer = invoice.customer || {};
            var hasCustomerData = customer.id || customer.fullName || customer.phone || customer.customerIdentity;
            if (!hasCustomerData) {
                if (invoice.shippingOption === 'RECEIVE_AT_HOME') {
                    delete request.customer.id;
                    delete request.customer.fullName;
                    delete request.customer.phone;
                    delete request.customer.phoneNumber;
                    delete request.customer.cpf;
                    delete request.customer.customerIdentity;
                } else {
                    request.customer = null;
                }
            }

            request.paymentCondition = null;
            request.availablePaymentConditions = angular.copy(invoice.availablePaymentConditions);
            request.paymentLinkMessage = options.paymentLinkMessage;
            if (invoice.items && invoice.items.length) {
                request.fixedValue = null;
                request.productName = null;
            } else {
                request.fixedValue = hasPositiveFixedValue(options.fixedValue) ? options.fixedValue : null;
                request.productName = options.standaloneProductName;
            }
            return request;
        }

        // Devolve a chave de erro (sufixo, sem prefixo) ou null. Espelha a validação de save()
        // do invoice-new: fora do contexto Immo, se o link estiver habilitado exige exatamente
        // uma condição de pagamento disponível; senão exige vm.invoice.paymentCondition.
        function validateInvoiceForSave(isImmoContext, paymentLinkEnabled, invoice, fixedValue) {
            if (isImmoContext) {
                return null;
            }
            if (paymentLinkEnabled) {
                if (hasPositiveFixedValue(fixedValue)) {
                    return 'fixed-value-requires-link';
                }
                if (!invoice.availablePaymentConditions.length) {
                    return 'select-single-payment-condition';
                }
                if (invoice.availablePaymentConditions.length > 1) {
                    return 'multiple-payment-conditions-not-allowed';
                }
            } else if (!invoice.paymentCondition) {
                return 'select-single-payment-condition';
            }
            return null;
        }

        function hasInvalidShippingAddress(invoice) {
            var customer = invoice.customer || {};
            return invoice.shippingOption === 'RECEIVE_AT_HOME' &&
                (!customer.address || !customer.zipcode || !customer.addressNumber
                    || !customer.district || !customer.city || !customer.state);
        }

        // Devolve a chave de erro do primeiro item inválido encontrado, ou null se todos válidos.
        function validateInvoiceItems(items, isImmoContext) {
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item.flyer.details && item.flyer.details.length && !item.detail) {
                    return isImmoContext ? 'has-immo-without-unit' : 'has-product-without-size';
                }
                if (!item.quantity) {
                    return 'has-product-without-quantity';
                }
                if (item.detail && item.detail.inventory <= 0 && item.detail.inventory !== null && !isImmoContext) {
                    return 'inventory-unavailable-product';
                }
            }
            return null;
        }

        // options: { fixedValue, isImmoContext, salesPoints, selectedSalesPointId }
        function validatePaymentLinkInvoice(invoice, options) {
            var conditions = invoice.availablePaymentConditions || [];
            if (conditions.indexOf('MONEY') !== -1) {
                return 'money-not-allowed-payment-link';
            }
            if (!conditions.length) {
                return 'select-payment-condition';
            }
            var hasItems = !!(invoice.items && invoice.items.length);
            if (!hasItems && !hasPositiveFixedValue(options.fixedValue)) {
                return 'select-a-product-or-fixed-value';
            }
            if (hasItems) {
                var itemKey = validateInvoiceItems(invoice.items, options.isImmoContext);
                if (itemKey) {
                    return itemKey;
                }
            }
            if (hasInvalidShippingAddress(invoice)) {
                return 'invalid-customer-address';
            }
            if (invoice.shippingOption === 'PICK_UP_IN_STORE' && options.salesPoints.length > 0 && !options.selectedSalesPointId) {
                return 'select-sales-point';
            }
            return null;
        }

        // Devolve a chave de erro (sufixo) ou null. hasErp controla a checagem extra de
        // documento (customerIdentity), presente só em invoice-new hoje — canonicalizada aqui.
        function validateCustomerBaseData(customer, hasErp) {
            customer = customer || {};
            if (!customer.id && !customer.fullName) {
                return 'invalid-customer-full-name';
            }
            if (!customer.id && !customer.phone) {
                return 'invalid-customer-phone';
            }
            if (hasErp && !customer.customerIdentity) {
                return 'invalid-customer-document';
            }
            return null;
        }
    }
})();
